import { useTranslation } from 'react-i18next';
import { Role } from '@/models/common/Role';

const roleChipClass = (role: string): string => {
  switch (role) {
    case Role.Admin:
      return 'bg-(--surface-secondary-lowest) text-(--font-primary)';
    case Role.Debugger:
      return 'bg-amber-50 text-amber-700';
    default:
      return 'bg-(--surface-grey-low) text-(--font-body-1)';
  }
};

interface RoleChipsProps {
  roles: string[];
}

const RoleChips = ({ roles }: RoleChipsProps) => {
  const { t } = useTranslation();

  if (roles.length === 0) {
    return <span className="text-(--font-body-3)">{t('usersManagement.roles.none')}</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {roles.map((role) => (
        <span key={role} className={`px-2 py-0.5 rounded-full body-xs-sm-regular ${roleChipClass(role)}`}>
          {t(`usersManagement.roles.${role}`, role)}
        </span>
      ))}
    </div>
  );
};

export default RoleChips;
